import React from 'react'
import { ReactComponent as SvgIcon } from '@fortawesome/fontawesome-pro/svgs/regular/low-vision.svg'
import PropTypes from 'prop-types'
import BaseIcon from '../../BaseIcon'

const LowVision = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 576 512" />
}

LowVision.propTypes = {
	className: PropTypes.string,
}

export default LowVision
